import { AsyncThunk, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { filterUrls } from '../../services/api.enums'
import { filterTableDataAPI } from '../../services/CRUDServices'

export const deliveryData: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  'deliveryList',
  async (body: any) => {
    let { data } = await filterTableDataAPI(
      filterUrls.filterDelivery,
      body.pageNumber,
      {
        ...body,
        pageNumber: body.pageNumber,
        pageSize: body?.pageSize ,
      },
      true,
      body?.pageSize,
      false
    )

    return {
      content: data.payload.content,
      totalElements: data.payload.totalElements,
    }
  }
)

const initialState: any = {
  deliveryList: [],
  fetchpost: false,
  errorMessage: null,
  filter: {},
}

const DeliveryList = createSlice({
  initialState: initialState,
  name: 'deliveryList',
  reducers: {
    updating: (state: any, action: any) => {
      state.isUpdating = action.payload
    },
    clearDelivery: (state) => {
      state.deliveryList = []
    },
    setFilter: (state, action) => {
      state.filter = action.payload
    },
  },
  extraReducers: {
    [deliveryData.fulfilled as any]: (state, action) => {
      state.deliveryList = action.payload
      state.fetchPost = false
    },
    [deliveryData.pending as any]: (state) => {
      state.fetchPost = true
    },
    [deliveryData.rejected as any]: (state) => {
      state.fetchPost = false
      state.errorMessage = 'wrong'
    },
  },
})

export const { clearDelivery, setFilter } = DeliveryList.actions
export default DeliveryList.reducer
